import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateQuestion, Question, QuestionListResponse, QuestionQueryParams, UpdateQuestion } from '@frontend/question/types';

export class QuestionClient extends APIClient {
    public static readonly endpoint = '/question-api/v1';

    public static async fetchQuestions(queryParams?: ApiQueryParams<DefaultQueryParams | QuestionQueryParams>): Promise<QuestionListResponse> {
        return await this.apiPaginated<QuestionListResponse, DefaultQueryParams>(`${this.endpoint}/questions`, queryParams);
    }

    public static async resolveQuestions(ids: string[]): Promise<QuestionListResponse> {
        const response = await this.post(`${this.endpoint}/questions-resolve`, { ids: ids });
        return await this.handleResponse<QuestionListResponse>(response);
    }

    public static async deleteQuestions(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/questions-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postQuestion(accountId: string, body: CreateQuestion): Promise<Question> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/questions`, body);
        return await this.handleResponse<Question>(response);
    }

    public static async patchQuestion(accountId: string, question_id: string, body: UpdateQuestion): Promise<Question> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/questions/${question_id}`, body);
        return await this.handleResponse<Question>(response);
    }

    public static async fetchQuestionsNotInGroup(accountId: string, groupId: string): Promise<QuestionListResponse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/groups/${groupId}/questions`);
        return await this.handleResponse<QuestionListResponse>(response);
    }

    public static async fetchQuestion(accountId: string, question_id: string): Promise<Question> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/questions/${question_id}`);
        return await this.handleResponse<Question>(response);
    }

    public static async deleteQuestion(accountId: string, question_id: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/questions/${question_id}`);
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
